import { render, staticRenderFns } from "./AutoReply.vue?vue&type=template&id=2c020f64&scoped=true&"
import script from "./AutoReply.vue?vue&type=script&lang=js&"
export * from "./AutoReply.vue?vue&type=script&lang=js&"
import style0 from "./AutoReply.vue?vue&type=style&index=0&id=2c020f64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c020f64",
  null
  
)

export default component.exports